import { loadResourcesUtils } from "@ane/core/lib/utils";
import CompositionResource from "../../resources/Composition.resource.js";
import { getTenantFromManagementGroup } from "@ane/exp-data/lib/utils/ManagementGroup";
import { buildCompositionInfo } from "./Composition.utils.js";
import { convertFlightDependencies } from "./CompositionEdit/CompositionEdit.utils.js";
import FeatureResources from "@ane/exp-data/lib/resources/FeatureResources";
const prefix = "FLIGHT_COMPOSITION";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const loadCompositionEpicReducerArg = {
  actionPrefix: `${prefix}/LOAD_FLIGHT_COMPOSITION`,
  reduxKeyNested: () => ["composition"],
  loadResource: (inputPayload) => CompositionResource.loadComposition(
    inputPayload.flightId,
    inputPayload.managementGroup,
    getTenantFromManagementGroup(inputPayload.managementGroup),
    inputPayload.workspaceId
  ),
  onCompleteSuccess: (resourceResult, inputPayload) => buildCompositionInfo(inputPayload.workspaceId, inputPayload.managementGroup, resourceResult)
};
const loadCompositionEpicReducer = loadResourcesUtils(loadCompositionEpicReducerArg);
const loadDependencyEpicReducerArg = {
  actionPrefix: `${prefix}/LOAD_FLIGHT_DEPENDENCY`,
  reduxKeyNested: () => ["dependencies"],
  loadResource: (inputPayload) => CompositionResource.loadDependency(
    inputPayload.flightId,
    inputPayload.managementGroup,
    getTenantFromManagementGroup(inputPayload.managementGroup),
    inputPayload.workspaceId
  ),
  onCompleteSuccess: (resourceResult, inputPayload) => convertFlightDependencies(inputPayload.flightId, resourceResult)
};
const loadDependencyEpicReducer = loadResourcesUtils(loadDependencyEpicReducerArg);
const queryFlightEpicReducerArg = {
  actionPrefix: `${prefix}/QUERY_FLIGHT`,
  reduxKeyNested: (inputPayload) => ["flightQueries", inputPayload.flightId],
  loadResource: (inputPayload) => FeatureResources.tryGetFlightRestResult(inputPayload.flightId, inputPayload.managementGroup, inputPayload.workspaceId),
  onCompleteSuccess: (resourceResult, inputPayload) => resourceResult
};
const queryFlightEpicReducer = loadResourcesUtils(queryFlightEpicReducerArg);
const updateCompositionActionPrefix = "UPDATE_COMPOSITION";
const updateCompostionActionTypes = {
  UPDATE: `${prefix}/${updateCompositionActionPrefix}/UPDATE`,
  UPDATING: `${prefix}/${updateCompositionActionPrefix}/UPDATING`,
  UPDATED: `${prefix}/${updateCompositionActionPrefix}/UPDATED`
};
const updateComposition = (flightId, managementGroup, workspaceId, verifyOnly, submitWithBlocking, request) => {
  return {
    type: updateCompostionActionTypes.UPDATE,
    payload: {
      flightId,
      managementGroup,
      workspaceId,
      verifyOnly,
      submitWithBlocking,
      request
    }
  };
};
const updatingComposition = (payload) => {
  return {
    type: updateCompostionActionTypes.UPDATING,
    payload
  };
};
const updatedComposition = (payload, result, isVerificationSuccess, resultMessage) => {
  return {
    type: updateCompostionActionTypes.UPDATED,
    payload: {
      flightId: payload.flightId,
      managementGroup: payload.managementGroup,
      workspaceId: payload.workspaceId,
      verifyOnly: payload.verifyOnly,
      submitWithBlocking: payload.submitWithBlocking,
      result,
      isVerificationSuccess,
      submissionMessage: resultMessage
    }
  };
};
const compositionEditActionPrefix = "COMPOSITION_EDIT";
const compositionEditActionTypes = {
  RESET_EDIT: `${compositionEditActionPrefix}/RESET_EDIT`,
  DISMISS_MESSAGE: `${compositionEditActionPrefix}/DISMISS_MESSAGE`,
  NAVIGATE_TO_COMPOSITION: `${compositionEditActionPrefix}/NAVIGATE_TO_COMP`,
  NAVIGATED_TO_COMPOSITION: `${compositionEditActionPrefix}/NAVIGATED_TO_COMP`
};
const resetCompositionEdit = (flightId) => {
  return {
    type: compositionEditActionTypes.RESET_EDIT,
    payload: { flightId }
  };
};
const dismissSubmissionMessage = (flightId) => {
  return {
    type: compositionEditActionTypes.DISMISS_MESSAGE,
    payload: { flightId }
  };
};
const navigateToComposition = (flightId, managementGroup, workspaceId) => {
  return {
    type: compositionEditActionTypes.NAVIGATE_TO_COMPOSITION,
    payload: { flightId, workspaceId, managementGroup }
  };
};
const navigatedToComposition = () => {
  return {
    type: compositionEditActionTypes.NAVIGATED_TO_COMPOSITION,
    payload: {}
  };
};
export {
  compositionEditActionTypes,
  createActionTypes,
  dismissSubmissionMessage,
  loadCompositionEpicReducer,
  loadDependencyEpicReducer,
  navigateToComposition,
  navigatedToComposition,
  queryFlightEpicReducer,
  resetCompositionEdit,
  updateComposition,
  updateCompostionActionTypes,
  updatedComposition,
  updatingComposition
};
//# sourceMappingURL=Composition.ducks.js.map
